import { registerStyle } from '@wordpress/style-runtime';
if (typeof process === 'undefined' || process.env.NODE_ENV !== 'test') {
	registerStyle("272b600f1c", ".dataviews-view-grid ._3f05eb69106ae604__filename,.dataviews-view-list ._3f05eb69106ae604__filename,.dataviews-view-table ._3f05eb69106ae604__filename{display:inline-block;max-inline-size:15ch;overflow:hidden;text-overflow:ellipsis;vertical-align:top;white-space:nowrap}");
}
export default {"filename":"_3f05eb69106ae604__filename"};
